import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)
import main from './main/index'; // 引入main模块的路由文件

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
//无效路由重定向至首页 /home
const redirect = [
    {
        path: '*',
        // 直接登录
        redirect: '/home/verify'
    }
]
//配置路由
const routes = [
    ...redirect,
    ...main,
]
//创建router实例
const router = new VueRouter({
    mode: "hash", //默认使用hash模式，若要使用history模式，生产环境下需后台进行配置 https://router.vuejs.org/zh/guide/essentials/history-mode.html
    routes
})
//全局前置守卫
router.beforeEach((to, from, next) => {
    if (to.path === '/home/verify') {
        next()
    } else {
        let a = sessionStorage.getItem('family')
        if(a){
            next()
        }else{
            next()

           // router.replace('/home/verify')
        }
    }
})
//全局后置钩子

export default router


// WEBPACK FOOTER //
// ./src/router/index.js